/**
 * FEATURE_FLAGS
 *
 * Represents the list of supported feature flags in the backend.
 *
 * Naming Convention:
 * - Feature flag values should be written as snake_case <feature_name>_<adjective>
 *   where <adjective> describes the feature flag's purpose.
 *  Example: 'historical_scenarios_enabled', 'rate_limit_activated'
 * - Enum keys should be written in UPPER_SNAKE_CASE
 *
 * Example:
 * HISTORICAL_SCENARIOS_ENABLED = 'historical_scenarios_enabled'
 * RATE_LIMIT_ACTIVATED = 'rate_limit_activated'
 */
export enum FEATURE_FLAGS {
  ACCOUNT_SETS_ENABLED = 'account_sets_enabled',
  ENHANCED_SCREENER_ENABLED = 'enhanced_screener_enabled',
  MULTI_PORTFOLIOS_STATEMENT_READER_ENABLED = 'multi_portfolios_statement_reader_enabled',
  PDF_CHART_AUTO_ALT_TEXT_ENABLED = 'pdf_chart_auto_alt_text_enabled',
  REFACTORING_COMPARISON_GROUP_LOGIC = 'refactoring_comparison_group_logic',
  SUB_ROWS_DATATABLEV2_ENABLED = 'sub_rows_datatablev2_enabled',
  TAX_ANALYSIS_CA_ENABLED = 'tax_analysis_ca_enabled',
  TAX_ANALYSIS_US_ENABLED = 'tax_analysis_us_enabled',
}
